
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Das Tessin in der ersten Welle`}</h2>
    <p>{`Besonders betroffen ist in der ersten Welle das Tessin. Die Intensivstationen sind zeitweise sogar stärker ausgelastet als in der zweiten Welle (detaillierte Zahlen dazu finden Sie im `}<a parentName="p" {...{
        "href": "https://interaktiv.tagesanzeiger.ch/2020/corona-spitalbetten-schweiz/"
      }}>{`Interaktiv-Dashboard`}</a>{`). Und im Südkanton sterben allein in der ersten Welle 300 Menschen an Corona – `}<a parentName="p" {...{
        "href": "https://www.nzz.ch/gesellschaft/wie-corona-das-tessin-an-den-rand-einer-katastrophe-brachte-und-die-willensnation-auf-die-probe-stellte-ld.1556749"
      }}>{`doppelt so viele`}</a>{` wie zu normalen Zeiten.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;